/** Supported canned-response variables. Only these tokens are substituted; anything
 * else (e.g. a stray `{weird}`) is left verbatim so unknown braces aren't eaten. */
const VARIABLE_TOKENS = ['buyer_name', 'part', 'price', 'business_name'];

const TOKEN_RE = new RegExp(`\\{(${VARIABLE_TOKENS.join('|')})\\}`, 'g');

/** Fill a snippet body from `context`. Unresolved/known-but-empty tokens become an
 * empty string (never the literal `{part}`); the resulting double-spaces are collapsed
 * and each line is trimmed so removed tokens don't leave ragged whitespace. */
function fillVariables(body, context = {}) {
  const filled = String(body).replace(TOKEN_RE, (_match, token) => {
    const value = context[token];
    return value == null ? '' : String(value);
  });
  return filled
    .split('\n')
    .map((line) => line.replace(/[ \t]{2,}/g, ' ').replace(/\s+([,.!?;:])/g, '$1').trim())
    .join('\n');
}

export { fillVariables, VARIABLE_TOKENS };
